<template>
    <div class="vendreVoiture-container page-container">
        <section class="bg-gray-100">
            <div class="container-xl container-1 pt-96 pt-lg-128 pb-64 px-3 px-xl-0">
                <div class="text-center text-gray-900 pt-lg-12 pb-2 mb-4 mb-lg-64">
                    <h1 class="title pb-3 fw-medium">Vendez Votre Voiture en Toute Simplicité</h1>
                    <p class="fsz-18">Choisissez entre le formulaire intelligent et la création manuelle pour mettre en vente votre voiture</p>
                </div>
                <div class="cards-container d-flex flex-row flex-wrap justify-content-center align-content-center">
                    <div>
                        <nuxt-link @click="handeladdAnouncement('/listing-form/vehicle-data?fresh=true', 'manuel')" class="bg-white card p-32 text-center d-flex flex-column justify-content-between" >
                        <div class="card-img d-flex justify-content-center align-content-center">
                            <img class="card-icon card-icon-manual card-icon-light" src="~/assets/images/cards/icon-create2.svg" alt="" />
                            <img class="card-icon card-icon-manual card-icon-dark" src="~/assets/images/cards/Manu.svg" alt="" />
                        </div>
                        <div class="card-body">
                            <h3 class="fw-semiBold fsz-16 text-gray-900 pb-3">Créez Votre Annonce Personnalisée</h3>
                            <p class="text-gray-600 fsz-14">Ajoutez des détails uniques et mettez en valeur les caractéristiques spéciales de votre voiture en toute simplicité</p>
                        </div>
                        <div class="btn btn-outline-primary-600 w-100">
                                Créer une annonce
                        </div>
                    </nuxt-link>
                    </div>
                    
                    <div>
                        <nuxt-link @click="handeladdAnouncement('/listing-form', 'automatique')" class="bg-white card p-32 text-center d-flex flex-column justify-content-between" >
                        <div class="card-img d-flex justify-content-center align-content-center">
                            <img class="card-icon card-icon-auto card-icon-light" src="~/assets/images/cards/icon-create1.svg" alt="" />
                            <img class="card-icon card-icon-auto card-icon-dark" src="~/assets/images/cards/Auto.svg" alt="" />
                        </div>
                        <div class="card-body">
                            <h3 class="fw-semiBold fsz-16 text-gray-900 pb-3">Vendez Votre Voiture en Quelques Clics</h3>
                            <p class="text-gray-600 fsz-14">Formulaire intelligent qui insère automatiquement les spécifications techniques et les options de votre voiture</p>
                        </div>
                        <div class="btn btn-outline-primary-600 w-100">
                                Créer une annonce
                        </div>
                    </nuxt-link>
                    </div>
                    <!-- 
                    Note: Static HTML used due to Nuxt 3 image loading issues

                    <div class="bg-white card p-32 text-center d-flex flex-column justify-content-between" v-for="(card,index) in CardsData" :key="index">
                        <div class="card-img d-flex justify-content-center align-content-center">
                            <NuxtImg :src="card.imgUrl"/>
                        </div>
                        <div class="card-body">
                            <h3 class="fw-semiBold fsz-16 text-gray-900 pb-3">{{ card.subTitle }}</h3>
                            <p class="text-gray-600 fsz-14">{{ card.description }}</p>
                        </div>
                        <nuxt-link :to="card.url" class="btn btn-outline-primary-600 w-100">
                                Créer une annonce
                        </nuxt-link>
                    </div> 
                    -->
                </div>
            </div>
        </section>
        <section>
            <div class="bg-white container-xl px-3 px-xl-0 ">
                <div class="steps-container mb-128">
                    <div class="text-center my-64">
                        <h1 class="title pb-2 fw-medium text-gray-900">Comment ça fonctionne sur Topauto.tn ?</h1>
                        <p class="fsz-16 text-gray-500">Découvrez comment profiter de la voiture de vos rêves en quatre étapes, sans besoins inutiles.</p>
                    </div>
                    <div class="step-container d-flex gap-4 flex-row flex-wrap steps-list position-relative justify-content-center justify-content-lg-start">
                        <div>
                            <div class="step-img position-absolute">
                                <img src="~/assets/images/vendreVoitureImg/s1.svg" />
                            </div>
                            <div class="mt-40">
                                <h3 class="text-gray-900 fsz-18 fw-semiBold pb-2 ">Remplissez le Formulaire</h3>
                                <p class="fsz-14">Commencez par remplir notre formulaire intuitif avec les détails de votre voiture.</p>
                            </div>
                        </div>
                        <div>
                            <div class="step-img position-absolute">
                                <img src="~/assets/images/vendreVoitureImg/s2.svg" />
                            </div>
                            <div class="mt-40">
                                <h3 class="text-gray-900 fsz-18 fw-semiBold pb-2 ">Personnalisez votre Annonce</h3>
                                <p class="fsz-14">Ajoutez des photos et personnalisez les détails de votre annonce pour attirer les acheteurs potentiels.</p>
                            </div>
                        </div>
                        <div>
                            <div class="step-img position-absolute">
                                <img src="~/assets/images/vendreVoitureImg/s3.svg" />
                            </div>
                            <div class="mt-40">
                                <h3 class="text-gray-900 fsz-18 fw-semiBold pb-2 ">Visite</h3>
                                <p class="fsz-14">Recevoir des demandes de renseignements et organiser des rendez-vous.</p>
                            </div>
                        </div>
                        <div>
                            <div class="step-img position-absolute">
                                <img src="~/assets/images/vendreVoitureImg/s4.svg" />
                            </div>
                            <div class="mt-40">
                                <h3 class="text-gray-900 fsz-18 fw-semiBold pb-2 ">Vente</h3>
                                <p class="fsz-14">Recevez des offres et vendez votre voiture en toute simplicité.</p>
                            </div>
                        </div>
                        <!-- 
                            Note: Static HTML used due to Nuxt 3 image loading issues

                            <div v-for="(step, index) in stepsData" :key="index">
                                <div class="step-img position-absolute">
                                    <NuxtImg :src="step.imgUrl"/>
                                </div>
                                <div class="mt-40">
                                    <h3 class="text-gray-900 fsz-18 fw-semiBold pb-2 ">{{ step.subTitle }}</h3>
                                    <p class="fsz-14">{{ step.description }}</p>
                                </div>
                                
                            </div>
                         -->
                    </div>
                </div>
                <div class="mt-2">
                    <div class="text-center mb-40">
                        <h1 class="title text-gray-900 pb-2 fw-medium">Vends ta voiture rapidement, simplement et gratuitement</h1>
                        <p class="text-gray-500 fsz-16">Une plateforme simple et gratuite pour mettre ta voiture en avant rapidement</p>
                    </div>
                    <div class="mt-2 mb-64 mx-lg-80" >
                        <div class="d-flex flex-md-row flex-column  mb-3">
                            <div class="me-xl-64 mt-lg-64" style="flex:1">
                                <h3 class="title text-gray-900 pb-3 pt-3">Préparation et Mise en Valeur</h3>
                                <p class="text-gray-500 fsz-16 pe-14 mb-3 mb-md-0" style="line-height: 24px;">Optimise les chances de vente de ta voiture en suivant nos conseils pratiques. De la préparation minutieuse, y compris le nettoyage et la correction des imperfections, à la photographie professionnelle, chaque étape compte pour présenter ton véhicule sous son meilleur jour. Une voiture bien entretenue et capturée de manière attrayante augmente considérablement son attrait sur le marché.</p>
                            </div>
                            <div class="img-container">
                                <img src="~/assets/images/vendreVoitureImg/Image_12.webp" class="w-100 h-100 "/>
                            </div>
                        </div>
                        <div class="d-flex flex-md-row-reverse flex-md-row flex-column " >
                            <div class="ms-xl-128 ms-md-32 mt-lg-64" style="flex:1" >
                                <h3 class="title text-gray-900 pb-2 fw-medium mb-32">Rencontres et Transactions</h3>
                                <p class="text-gray-500 fsz-16 me-14 mb-3 mb-md-0" style="line-height: 24px;">Lorsque tu as des acheteurs potentiels, organise des rendez-vous et dévoile tes compétences de négociateur. Présente ta voiture de manière attrayante, en toute transparence sur d’éventuels défauts ou accidents passés. La loi exige que tu informes l’acheteur de tout défaut connu. Pour les essais, demande des garanties telles qu’une carte d’identité en cours de validité et vérifie la validité de son permis de conduire.</p>
                            </div>
                            <div class="img-container">
                                <img src="~/assets/images/vendreVoitureImg/Car-men-tested.webp" class="w-100 h-100 "/>
                            </div>
                        </div>
                    </div>
                    <div class="mt-14 mb-80 d-flex flex-row flex-wrap justify-content-center justify-content-xl-start aventageCards-container">
                        <div class="aventageCard p-4 " v-for="(aventage,index) in aventageCards" :key="index">
                            <div class="avatar avatar-icon bg-primary-50 text-primary-600 ">
                                <span class="material-symbols-rounded fsz-20">{{ aventage.icon }}</span>
                            </div>
                            <div class="text-gray-900 pt-3">
                                <h4 class="fsz-16 fw-semiBold pb-2">{{ aventage.title }}</h4>
                                <p class="fsz-14">{{ aventage.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="bg-primary-600 ">
            <div class="container-xl px-3 px-xl-256 py-40 d-flex flex-column justify-content-center align-content-center">
                <div class="text-center pt-12">
                    <h4 class="text-white title mb-4">Nous sommes là pour vous aider</h4>
                    <p class="text-white">Notre équipe dévouée est là pour répondre à vos questions, vous guider à travers le processus et assurer une expérience sans faille. Nous sommes là pour vous aider à chaque étape.</p>
                </div>
                <div class="d-flex justify-content-center mt-20">
                    <NuxtLink class="btn btn-outline-primary-600 d-flex align-items-center medium-btn fsz-14" to="/contactez-nous">
                        <span class="material-symbols-rounded fsz-18 me-1">{{ icons.arrow }}</span>
                        Contactez-nous
                    </NuxtLink>
                </div>
            </div>
        </section>
       
       
    </div>
    <DialogsBilling :visible="billingModal" @update:visible="(e) => billingModal = e" :lowCredits="true"  />
    <UiElementContactEmbed/>
</template>

<script setup lang="ts">
const icons = reactive({
  clock: 'schedule',
  start: 'star',
  dollar: 'paid',
  check: 'verified',
  arrow: 'arrow_forward',
})
const billingModal = ref(false);

// const CardsData = [
//     {
//         subTitle: "Vendez Votre Voiture en Quelques Clics",
//         description: "Formulaire intelligent qui insère automatiquement les spécifications techniques et les options de votre voiture",
//         url:"/listing-form",
//         imgUrl:"cards/icon-create1.svg",
//     },
//     {
//         subTitle: "Créez Votre Annonce Personnalisée",
//         description: "Ajoutez des détails uniques et mettez en valeur les caractéristiques spéciales de votre voiture en toute simplicité",
//         url:"/listing-form/vehicle-data?fresh=true",
//         imgUrl:"cards/icon-create2.svg",
//     }
// ]

// const stepsData= [
//     {
//         imgUrl: "vendreVoitureImg/s1.svg",
//         subTitle: "Remplissez le Formulaire",
//         description: "Commencez par remplir notre formulaire intuitif avec les détails de votre voiture.",
//     },
//     {
//         imgUrl: "vendreVoitureImg/s2.svg",
//         subTitle: "Personnalisez votre Annonce",
//         description: "Ajoutez des photos et personnalisez les détails de votre annonce pour attirer les acheteurs potentiels.",
//     },
//     {
//         imgUrl: "vendreVoitureImg/s3.svg",
//         subTitle: "Visite",
//         description: "Recevoir des demandes de renseignements et organiser des rendez-vous.",
//     },
//     {
//         imgUrl: "vendreVoitureImg/s4.svg",
//         subTitle: "Vente",
//         description: "Recevez des offres et vendez votre voiture en toute simplicité.",
//     },

// ]
const aventageCards= [
    {
        title: "Facilité en Quelques Étapes",
        description: "Crée ton annonce en quelques minutes seulement",
        icon: icons.clock
    },
    {
        title: "Audience Étendue",
        description: "Touche des millions de personnes intéressées",
        icon: icons.start
    },
    {
        title: "Meilleur Prix Garanti",
        description: "Négocie et obtiens le meilleur prix possible",
        icon: icons.dollar

    },
    {
        title: "Gratuit",
        description: "Annonce de base gratuite, avec l’option d’améliorer la visibilité",
        icon: icons.check

    },
]
const dash = useDashboardStore();
const runTimeConfig = useRuntimeConfig();
const route = useRoute();
const cookie = useCookie("userToken");

type AnnouncementTelegramType = 'manuel' | 'automatique';

const sendAddAnnouncementTelegram = async (type: AnnouncementTelegramType) => {
  try {
    await $fetch("/announcements/addAnnouncementTelegram", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${cookie.value}`,
      },
      body: {
        type,
      },
      baseURL: runTimeConfig.public.baseUrl,
    });
  } catch (error) {
    // console.log(error);
  }
};

const handeladdAnouncement = (url: string, type: AnnouncementTelegramType)=>{
    void sendAddAnnouncementTelegram(type);

    if(!dash.getUserProfil){
        navigateTo('/authentication/login');
        return
    }
    if(dash.getUserProfil.freeCredits + dash.getUserProfil.additionalCredits < Number(runTimeConfig.public.newAnnouncementCredits)){
        billingModal.value = true;
    } else 
        navigateTo(url)
        if (type === 'automatique')
        {
            trackAnnouncementStarted({ announce_type_created: 'Automatique' });
            trackVehicleBasicInfoStarted();
        } else {
            trackAnnouncementStarted({ announce_type_created: 'Manuel' });
        }
        
}

const seoUrl = ref();
const seoImage = ref();

const seoTitle = `Vendre sa voiture en Tunisie | Publiez votre annonce sur TopAuto`;
const seoDescription = `Vendez votre voiture rapidement sur TopAuto. Créez votre annonce auto en quelques clics, attirez des acheteurs sérieux et concrétisez votre vente en toute confiance.`;
seoUrl.value = `${runTimeConfig.public.clientBaseUrl}${route.fullPath}`;
seoImage.value = `${runTimeConfig.public.clientBaseUrl}/_nuxt/assets/images/logos/Logo-B.png`;

useHead({
  title: seoTitle,
  link: [
    {
      rel: 'canonical',
      href: seoUrl
    }
  ],
  meta: [
    {
      name: 'description',
      content: seoDescription
    },
    {
      property: 'og:title',
      content: seoTitle
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:description',
      content: seoDescription
    },
    {
      property: 'og:url',
      content: seoUrl
    },
    {
      property: 'og:image',
      content: seoImage
    },
    {
      property: 'og:site_name',
      content: 'TopAuto'
    }
  ]
});

definePageMeta({
    layout: "client-layouts",
});

</script>

<style scoped lang="scss">

</style>
